import requests from "./httpService";

const NotificationServices = {

    getNotification: async () => {
        return requests.get(`/notifications`);
    },
    createNotification: async (body) => {
        return requests.post(`/notifications`, body);
    },
    updateNotification: async (id, body) => {
        return requests.put(`/notifications/${id}`, body);
    },
    deleteNotification: async (id) => {
        return requests.delete(`/notifications/${id}`);
    },
}

export default NotificationServices;
